import { deleteExportHistoryPendingFile } from '@/services/call-log-service/call-log-service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useDeleteExportHistoryPendingFile = () => {
  const queryClient = useQueryClient();

  const { mutate: deleteExportHistory, isPending: isDeletingExportHistory } = useMutation({
    mutationFn: (id: number) => deleteExportHistoryPendingFile(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['export-history'] });
    },
  });

  return { deleteExportHistory, isDeletingExportHistory };
};
